(function () {
  'use strict'

  require('./expanded-content')

  require('./scss/expanded-content.scss')

  var MODULE_NAME = 'thismoment.expandedContent'

  angular
    .module(MODULE_NAME, [
      'thismoment.expandedContent.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/expandedContent/index.js